module.exports = __webpack_public_path__ + "static/media/hand.6cbe4f41.svg";